const loadingIndicator = {
  Start: 'start',
  Stop: 'stop'
};
export { loadingIndicator };